export const LANGUAGE_STORAGE_KEY = 'mc-student-language';
export const ITEM_INDEX_STORAGE_KEY = 'mc-student-item-index';

// A non-bank assessment advertises no languages, so it gets no selector.
export const shouldShowSelector = (availableLanguages) =>
  Array.isArray(availableLanguages) && availableLanguages.length > 0;

export const selectorOptions = (availableLanguages) => [
  'en',
  ...(availableLanguages ?? []).filter((code) => code !== 'en'),
];

// The question language comes only from the selector, which stores its choice for the switch
// reload, so a fresh tab starts in English. The UI language (`lng`, setup/i18n.js) is separate.
export const resolveInitialLanguage = ({ availableLanguages, stored }) =>
  selectorOptions(availableLanguages).includes(stored) ? stored : 'en';

export const readStoredLanguage = (storage) => {
  try {
    return storage.getItem(LANGUAGE_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const writeStoredLanguage = (storage, lang) => {
  try {
    storage.setItem(LANGUAGE_STORAGE_KEY, lang);
  } catch {
    // Private mode or a full quota: the choice is not kept.
  }
};

// The question the student was on, kept across the switch reload so Learnosity can return to it.
export const writeStoredItemIndex = (storage, index) => {
  try {
    storage.setItem(ITEM_INDEX_STORAGE_KEY, String(index));
  } catch {
    // Private mode or a full quota: the reload opens the first question.
  }
};

// Read once and removed, so only the load right after a switch jumps.
export const takeStoredItemIndex = (storage) => {
  try {
    const stored = storage.getItem(ITEM_INDEX_STORAGE_KEY);
    storage.removeItem(ITEM_INDEX_STORAGE_KEY);
    const index = Number.parseInt(stored, 10);
    return Number.isNaN(index) ? null : index;
  } catch {
    return null;
  }
};
